/* Responsibility: Sends filters to the server, and notifies that new results must be rendered */
import preconditions from '../../lib/preconditions.js';

const checkPreconditions = preconditions('refreshResultsOnFilterChange', {
    getResults: 'function',
    eventHub: 'eventHub',
});

function handleError(err, eventHub) {
    if (err.status === 410) {
        eventHub.publish('result-expired');
    } else {
        throw new TypeError(`Filter search failed: ${JSON.stringify(err)}`);
    }
}

export default function refreshResultsOnFilterChange(params) {
    checkPreconditions(params);

    const handleResults = (err, data) => {
        if (err) {
            handleError(err, params.eventHub);
        } else {
            params.eventHub.publish('changed-results', data, { firstResult: false });
            if (typeof data.stats !== 'undefined') {
                params.eventHub.publish('changed-stats', data.stats);
            }
        }
    };

    params.eventHub.subscribe('resultViewCriteria:changed', () => {
        params.getResults(handleResults);
    });
}
